<template>
  <div class="grid-card-row" :style="cssVars">
    <slot />
  </div>
</template>

<script>
/**
 * Linha do grid de 12 colunas que organiza GridCards.
 * Cada filho GridCard define quantas colunas ocupa via prop `cols`.
 *
 * Exemplo:
 *  <GridCardRow>
 *    <GridCard :cols="6" titulo="A" />
 *    <GridCard :cols="6" titulo="B" />
 *  </GridCardRow>
 */
export default {
  name: "GridCardRow",
  props: {
    gap: { type: [Number, String], default: 14 },
    colunas: { type: Number, default: 12 },
  },
  computed: {
    cssVars() {
      return {
        "--grid-card-gap": `${this.gap}px`,
        "--grid-card-cols": this.colunas,
      };
    },
  },
};
</script>

<style scoped>
.grid-card-row {
  display: grid;
  grid-template-columns: repeat(var(--grid-card-cols, 12), minmax(0, 1fr));
  gap: var(--grid-card-gap, 14px);
}

@media (max-width: 768px) {
  .grid-card-row {
    grid-template-columns: 1fr;
  }
}
</style>
